export enum ShopProductCategoryEnum {
  EducationAndCulture = 1,
  EatAndDrink = 2,
  HealthAndBeauty = 3,
  EventAndActivity = 4,
}
